import React from "react";
import { getNextGoalOdds, getNextGoalOptionOdd } from "../functions";

const to2dp = (num) => (Number.isFinite(num) ? num.toFixed(2) : "-");

// Try helper, fall back to scanning options array if present
const getOpt = (label, oddsMarket) => {
  if (!oddsMarket) return { n: label, v: undefined };

  // 1) Use your helper first
  try {
    const viaHelper = getNextGoalOptionOdd(label, oddsMarket);
    if (viaHelper && (Number.isFinite(viaHelper.v) || viaHelper.v === 0)) {
      return { n: viaHelper.n ?? label, v: Number(viaHelper.v) };
    }
  } catch (_) {}

  // 2) Fallback: scan oddsMarket.o for a matching name (case/space-insensitive)
  const opts = Array.isArray(oddsMarket.o) ? oddsMarket.o : [];
  const wanted = String(label).replace(/\s+/g, "").toUpperCase();
  const match =
    opts.find((o) => String(o?.n ?? "").replace(/\s+/g, "").toUpperCase() === wanted) ||
    // extra aliases
    (label === "No goal" &&
      opts.find((o) =>
        ["NOGOAL", "NO_GOAL", "NG"].includes(String(o?.n ?? "").replace(/\s+/g, "").toUpperCase())
      ));

  if (match && (Number.isFinite(match.v) || match.v === 0)) {
    return { n: match.n, v: Number(match.v) };
  }

  return { n: label, v: undefined };
};

const NextGoal = ({ blocked, odds, totalGoals }) => {
  const markets = Array.isArray(odds) ? odds : [];

  // Your helper should return the single "next goal" market;
  // it sometimes returns undefined/null — guard it.
  let nextGoalOdds = null;
  try {
    nextGoalOdds = getNextGoalOdds(markets, totalGoals) || null;
  } catch {
    nextGoalOdds = null;
  }

  // If blocked (truthy but not 0) or no market, render 3 empty cells to keep table geometry
  const isBlocked = !!blocked && blocked !== 0;
  if (!nextGoalOdds || isBlocked) {
    return <td className="opacity-90" colSpan="3" />;
  }

  // Build the three cells safely
  const labels = ["1", "No goal", "2"];
  const cells = labels.map((lab) => getOpt(lab, nextGoalOdds));

  return (
    <>
      {cells.map(({ n, v }) => (
        <td className="opacity-90 text-center" key={String(n)}>
          {to2dp(v)}
          <br />
        </td>
      ))}
    </>
  );
};

export default NextGoal;
